import {Outlet} from 'react-router'

/**
 * Toile layout shell — pathless, renders only the route outlet. Header and footer are rendered
 * per-route (narcis/ovid pattern: `_layout.tsx`'s own doc comments), so each surface controls its own
 * header accent state.
 */
export default function Layout() {
    return <Outlet />
}
